// 通用数据
export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  }
}
